/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Close_RegistrationInputs */



/**
* | output |
* | --- |
* | "Start Check-in" |
*
* @param {Overview_Close_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_close_registration = /** @type {((inputs?: Overview_Close_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Close_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer le pointage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Iniciar Check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia Check-in")
	return /** @type {LocalizedString} */ ("Start Check-in")
});